import { Chip, Stack, Typography } from '@mui/material';
import { Box } from '@mui/material';
import { People } from '@mui/icons-material';
import { variants } from '../../../../variants/variants';
import UserAvatar from '../../../../common/UserAvatar';

const CustomRow = ({ delight }) => {
  return (
    <Stack direction={'row'} alignItems={'center'} sx={{ border: 0 }}>
      <Box sx={{ ml: 1 }}>
        {/* <Typography sx={{ fontSize: variants.BODY, }}>{delight[2]}</Typography> */}
        <Stack direction={'row'} alignItems={'center'} sx={{ mb: 0.5 }}>
          <Typography sx={{ fontSize: variants.TINY, color: variants.typography.active.main, fontWeight: 600 }}>
            {delight[1]}
          </Typography>
          <Stack direction={'row'} alignItems={'center'} ml={1}>
            <People fontSize='small' sx={{ mr: 0.5 }} />
            <Typography sx={{ fontSize: variants.TINY, color: variants.typography.active.main, fontWeight: 600 }}>
              {delight[2]}
            </Typography>
          </Stack>
        </Stack>
        <Typography sx={{ fontSize: variants.BODY }}>{delight[3]}</Typography>
      </Box>

      <Stack sx={{ ml: 'auto' }}>
        <Stack direction={'row'} justifyContent={'flex-end'}>
          <Typography sx={{ fontSize: variants.TINY, mr: 1 }}>HR:</Typography>
          <Chip
            size='small'
            sx={{
              mb: 1,
              backgroundColor:
                delight[4] === 'Pending'
                  ? 'rgba(255, 193, 7, 0.16)'
                  : delight[4] === 'Approved'
                  ? 'rgba(84, 214, 44, 0.16)'
                  : delight[4] === 'Rejected'
                  ? 'rgba(255, 72, 66, 0.16)'
                  : 'black',
              color:
                delight[4] === 'Pending'
                  ? '#B78103'
                  : delight[4] === 'Approved'
                  ? '#229A16'
                  : delight[4] === 'Rejected'
                  ? 'red'
                  : 'black',
              borderRadius: '6px',
              width: '5.5rem',
              fontWeight: 'bold',
            }}
            label={delight[4]}
          />
        </Stack>
        <Stack direction={'row'} justifyContent={'flex-end'}>
          <Typography sx={{ fontSize: variants.TINY, mr: 1 }}>Admin:</Typography>

          <Chip
            size='small'
            sx={{
              backgroundColor:
                delight[5] === 'Pending'
                  ? 'rgba(255, 193, 7, 0.16)'
                  : delight[5] === 'Approved'
                  ? 'rgba(84, 214, 44, 0.16)'
                  : delight[5] === 'Rejected'
                  ? 'rgba(255, 72, 66, 0.16)'
                  : 'black',
              color:
                delight[5] === 'Pending'
                  ? '#B78103'
                  : delight[5] === 'Approved'
                  ? '#229A16'
                  : delight[5] === 'Rejected'
                  ? 'red'
                  : 'black',
              borderRadius: '6px',
              width: '5.5rem',
              fontWeight: 'bold',
            }}
            label={delight[5]}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};
export default CustomRow;
